import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgOpenParenthesis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    x={0}
    y={0}
    viewBox="0 0 17 56.7"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M15.1 54.5c-1.3-.2-2.4-.7-3.4-1.5-.8-.8-1.5-1.8-2-2.9-.9-2.3-3.1-8.4-3.1-21.8S8.8 8.9 9.8 6.6c.5-1.1 1.2-2.1 2-2.9q1.5-1.2 3.3-1.5h.1c.4-.1.6-.4.6-.8-.1-.3-.3-.6-.6-.6-1.6-.2-3.2.1-4.7.8-1.5.8-2.7 1.9-3.7 3.2q-2.55 3.9-3.6 8.4l-.1.3C.6 23.2.6 33.3 3.1 43l.1.3q1.05 4.5 3.6 8.4c.9 1.3 2.2 2.4 3.6 3.2 1.5.7 3.1.9 4.7.8.4 0 .7-.4.6-.7 0-.2-.2-.5-.6-.5"
      fill="currentColor"
    />
  </svg>
);
